import React, { useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';
import logo from '../assets/logo_3.png';
import { BsBell, BsImages } from "react-icons/bs";
import { LuClipboardPlus, LuNotebookPen } from "react-icons/lu";
import ProfileImage from './ProfileImage.js';

function Header({
  userReviews,
  user,
  onLogout,
  onShowLoginPrompt,
  onCreateReviewClick,
  notifications
}) {
  const buttonRef = useRef(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleDrawer = (e) => {
    e.stopPropagation();
    setIsMenuOpen(!isMenuOpen);
  };

  // Close menu when clicking outside
  React.useEffect(() => {
    const handleClickOutside = (event) => {
      if (buttonRef.current && !buttonRef.current.contains(event.target)) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div style={{ zIndex: '10', height: '45px' }}>
      <div className="container App-header" style={{ background: 'white', position: 'fixed', top: '0', right: '0', left: '0', zIndex: '10000' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', position: 'relative', zIndex: '99' }}>
          <div className="left-side">
            <div className="header-left">
              <Link to="/">
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <img src={logo} alt="Surgery Journey Logo" className="header-logo" />
                  <div className="text-header">
                    <div style={{ fontWeight: 'bold', fontSize: '16px', textAlign: 'left', height: '14px', lineHeight: '14px' }}>Surgery</div>
                    <div style={{ fontWeight: 'bold', fontSize: '16px', textAlign: 'left', height: '14px', lineHeight: '14px' }}>Journey</div>
                  </div>
                </div>
              </Link>
            </div>
          </div>
          <div className="right-bottom">
            <div>
              <span
                className="header-nav-tooltip"
                data-tooltip="Add surgery experience"
              >
                <button
                  type="button"
                  className="notification-bell-button"
                  onClick={onCreateReviewClick}
                  aria-label="Add surgery experience"
                >
                  <LuClipboardPlus aria-hidden />
                </button>
              </span>
            </div>
            {!user && (
              <div className="bottom-right-button">
                <button
                  className="post-update-button"
                  onClick={onShowLoginPrompt}
                >
                  Login
                </button>
              </div>
            )}
            {!!user && (
              <>
                <div className="notification-bell-container">
                  <span
                    className="header-nav-tooltip"
                    data-tooltip="Notifications"
                  >
                    <Link
                      to="/notifications"
                      className="notification-bell-button"
                      aria-label="Notifications"
                    >
                      <BsBell aria-hidden />
                      {notifications.filter(notification => !notification.isRead).length > 0 && (
                        <span className="notification-badge">
                          {notifications.filter(notification => !notification.isRead).length}
                        </span>
                      )}
                    </Link>
                  </span>
                </div>
                <div>
                  <span
                    className="header-nav-tooltip"
                    data-tooltip="Pain diary"
                  >
                    <Link
                      to="/diary"
                      className="notification-bell-button"
                      aria-label="Pain diary"
                    >
                      <LuNotebookPen aria-hidden />
                    </Link>
                  </span>
                </div>
                <div>
                  <span
                    className="header-nav-tooltip"
                    data-tooltip="Images"
                  >
                    <Link
                      to="/images"
                      className="notification-bell-button"
                      aria-label="Images"
                    >
                      <BsImages aria-hidden />
                    </Link>
                  </span>
                </div>
                <div className="user-menu">
                  <div
                    ref={buttonRef}
                    className="user-icon-button"
                    onClick={toggleDrawer}
                    aria-label="User menu"
                    style={{ padding: '0', height: '30px' }}
                  >
                    <ProfileImage profile={user} size={40} />
                    {isMenuOpen && (
                      <div className="user-flyout-menu">
                        <div className="user-info">
                          Logged in as {user?.username}
                        </div>
                        {
                          (userReviews && userReviews?.length) && (
                            <div className="user-info">
                              <Link to={`/surgeries/?user=${user.id}`} className="hide-link-styles user-info-link">Your Surgeries ({userReviews.length})</Link>
                            </div>
                          )
                        }
                        <div className="user-info">
                          <Link to="/diary" className="hide-link-styles user-info-link">Pain Diary</Link>
                        </div>
                        <div className="user-info">
                          <Link to="/images" className="hide-link-styles user-info-link">Your Images</Link>
                        </div>
                        <button
                          className="flyout-logout-button"
                          onClick={onLogout}
                        >
                          <span className="power-icon">⎋</span> Logout
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Header; 